import { useState } from "react";
import styles from "./ReportsABC.module.css";
import CustomSelect from "../../customComponents/CustomSelect";

const ReportsABC = () => {
  const [selectedWarehouse, setSelectedWarehouse] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const data = [
    {
      id: 1,
      product: "Товар 1",
      purchasePrice: "1 000 ₸",
      markup: "20%",
      category: "Категория A",
      salePrice: "1 200 ₸",
      salesCount: "50",
      salesCost: "50 000 ₸",
      salesRetail: "60 000 ₸",
      profit: "10 000 ₸",
      salesPerDay: "5",
      profitShare: "10%",
      cumulativeProfit: "10%",
      abc: "A",
      summary: "Топ продаж",
    },
    {
      id: 2,
      product: "Товар 2",
      purchasePrice: "800 ₸",
      markup: "25%",
      category: "Категория B",
      salePrice: "1 000 ₸",
      salesCount: "30",
      salesCost: "24 000 ₸",
      salesRetail: "30 000 ₸",
      profit: "6 000 ₸",
      salesPerDay: "3",
      profitShare: "6%",
      cumulativeProfit: "16%",
      abc: "B",
      summary: "Средний уровень",
    },
  ];

  return (
    <div className={styles.container}>
      {/* Заголовок */}
      <div className={styles.header}>
        <h2>ABC анализ</h2>
        <p>Раздел для анализа эффективности товаров и категорий по методу ABC.</p>
      </div>

      {/* Фильтры */}
      <div className={styles.filters}>
        <CustomSelect
          className={styles.select}
          options={["Кокшетау", "Караганда", "Астана"]}
          value={selectedWarehouse}
          onChange={setSelectedWarehouse}
          placeholder="Склад"
        />
        <CustomSelect
          className={styles.select}
          options={["Категория A", "Категория B", "Категория C"]}
          value={selectedCategory}
          onChange={setSelectedCategory}
          placeholder="Категория"
        />
        <input
          type="date"
          className={styles.dateInput}
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
        />
      </div>

      {/* Таблица */}
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>#</th>
              <th>Товар</th>
              <th>Закуп. цена</th>
              <th>Наценка</th>
              <th>Категория</th>
              <th>Прод. цена</th>
              <th>Кол-во продаж</th>
              <th>Сумма продаж по с/с</th>
              <th>Сумма продаж по р/ц</th>
              <th>Прибыль</th>
              <th>Продажи в день</th>
              <th>Доля в прибыли</th>
              <th>Накоп. вклад в прибыли</th>
              <th>ABC по с/с</th>
              <th>Свод</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row) => (
              <tr key={row.id}>
                <td>{row.id}</td>
                <td>{row.product}</td>
                <td>{row.purchasePrice}</td>
                <td>{row.markup}</td>
                <td>{row.category}</td>
                <td>{row.salePrice}</td>
                <td>{row.salesCount}</td>
                <td>{row.salesCost}</td>
                <td>{row.salesRetail}</td>
                <td>{row.profit}</td>
                <td>{row.salesPerDay}</td>
                <td>{row.profitShare}</td>
                <td>{row.cumulativeProfit}</td>
                <td>{row.abc}</td>
                <td>{row.summary}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReportsABC;
